// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__JkcOy","header":"ReportDetails_header__3Imcn","title":"ReportDetails_title__3mo8w","left":"ReportDetails_left__2cicn"};